module.exports = __webpack_public_path__ + "media/packs/images/flags/PE-8f56480c4a48e17044be36ea67f3dc2a.svg";